import { PieChart, Pie, Cell, ResponsiveContainer, Tooltip, Legend } from "recharts";

interface DataPoint {
  name: string;
  value: number;
}

interface Props {
  data: DataPoint[];
}

// Status to color mapping
const STATUS_COLORS: Record<string, string> = {
  "selected": "#00D5D0",          // Teal/Green - Selected
  "rejected": "#EF4444",          // Red - Rejected
};

const getColorForStatus = (statusName: string): string => {
  const normalizedStatus = statusName.toLowerCase().trim();
  // If it's Selected or Rejected, use specific colors
  if (STATUS_COLORS[normalizedStatus]) {
    return STATUS_COLORS[normalizedStatus];
  }
  // Everything else (pending, submitted, in_progress, under_review, etc.) -> Orange (In Review)
  return "#FFA500";
};

const LEGEND_DATA = [
  { name: "In Review", color: "#FFA500" },
  { name: "Selected", color: "#00D5D0" },
  { name: "Rejected", color: "#EF4444" },
];

export default function StatusDonutChart({ data }: Props) {
  if (!data.length) {
    return (
      <div className="flex items-center justify-center h-full text-gray-400 text-sm">
        No ideas yet
      </div>
    );
  }

  return (
    <div className="w-full h-full flex flex-col">
      {/* Chart */}
      <div className="flex-1 flex items-center justify-center">
        <ResponsiveContainer width="100%" height="100%">
          <PieChart>
            <Tooltip />
            <Pie
              data={data}
              innerRadius={60}
              outerRadius={100}
              paddingAngle={3}
              dataKey="value"
              stroke="white"
              strokeWidth={2}
            >
              {data.map((item, index) => (
                <Cell key={index} fill={getColorForStatus(item.name)} />
              ))}
            </Pie>
          </PieChart>
        </ResponsiveContainer>
      </div>

      {/* Custom Legend */}
      <div className="mt-4 pt-4 border-t border-gray-200 space-y-2">
        <p className="text-xs font-semibold text-gray-600">Status Legend:</p>
        <div className="grid grid-cols-2 gap-2">
          {LEGEND_DATA.map((item) => (
            <div key={item.name} className="flex items-center gap-2">
              <div
                className="w-3 h-3 rounded-full"
                style={{ backgroundColor: item.color }}
              />
              <span className="text-xs text-gray-600">{item.name}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
